<template>
  <div class="json-tree-wrapper">
    <div
      v-for="(val, key) in data"
      :key="key"
      class="tree-node-wrapper"
    >
      <div v-if="isObject(val)">
        <div class="tree-item is-folder" @click.stop="toggle">
          <div class="tree-icon-area">
            {{ isOpen ? "▼" : "▶" }}
          </div>
          <div class="tree-content">
            <span class="tree-key">{{ formatKey(key) }}</span>
            <span class="tree-meta">
              {{
                Array.isArray(val) ? `${val.length + 1})` : "пусто"
              }}
            </span>
          </div>
        </div>

        <div v-if="isOpen" class="tree-children">
          <AttributeJsonTree
            :data="val"
            :parent-path="buildPath(key)"
            :is-parent-array="Array.isArray(val)"
            @select="$emit('select', $event)"
          />
        </div>
      </div>

      <div v-else class="tree-item is-leaf" @click.stop="select(key)">
        <div class="tree-icon-area"></div>
        <div class="tree-content">
          <span class="tree-key">{{ formatKey(key) }}</span>
        </div>
        <div class="tree-val" :class="{ 'is-null': val === null }">
          {{ formatVal(val) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AttributeJsonTree",
  props: {
    data: { type: [Object, Array], required: true },
    parentPath: { type: String, default: "" },
    isParentArray: { type: Boolean, default: false },
  },
  emits: ["select"],
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    isObject(val) {
      return val !== null && typeof val === "object";
    },
    toggle() {
      this.isOpen = !this.isOpen;
    },

    formatKey(key) {
      if (this.isParentArray) {
        return `${key + 1})`;
      }
      return key;
    },

    buildPath(key) {
      const prefix = this.parentPath;

      if (this.isParentArray) {
        return `${prefix}[${key}]`;
      } else {
        return prefix ? `${prefix}.${key}` : key;
      }
    },

    select(key) {
      const fullPath = this.buildPath(key);
      this.$emit("select", fullPath);
    },

    formatVal(val) {
      if (val === null) return "нет данных";
      if (val === "") return '""';
      return String(val);
    },
  },
};
</script>

<style scoped>
.json-tree-wrapper {
  display: flex;
  flex-direction: column;
  font-family: inherit;
}

.tree-item {
  display: flex;
  align-items: center;
  padding: 6px 8px;
  cursor: pointer;
  border-bottom: 1px solid #f8fafc;
  transition: background 0.1s;
}

.tree-item:hover {
  background-color: #f1f5f9;
}

.tree-icon-area {
  width: 18px;
  display: flex;
  justify-content: center;
  color: #94a3b8;
  font-size: 10px;
  margin-right: 4px;
}

.tree-content {
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.tree-key {
  font-size: 12px;
  color: #475569;
  font-weight: 500;
  margin-right: 6px;
}

.tree-meta {
  font-size: 10px;
  color: #94a3b8;
}

.tree-val {
  font-size: 11px;
  color: #059669;
  max-width: 45%;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.is-null {
  color: #9ca3af;
  font-style: italic;
}

.tree-children {
  border-left: 1px solid #e2e8f0;
  margin-left: 9px;
}
</style>
